import {StageLayer} from "@nolimitcity/slot-launcher/bin/StageLayer";
import {TheBorder} from "../TheBorder";
import {TheBorderGameAssets} from "../TheBorderGameAssets";

export class TheBorderXRipReelHighlighter extends PIXI.Container implements StageLayer {
    private _animation: PIXI.spine.Spine;

    public highlightReel(): void {
        if (this._animation && !TheBorder.isInFS) {
            this.resetSpine();
            this._animation.state.setAnimation(0, "highlighter_xrip", true);
        }
    }

    public stopHighlight(): void {
        if (this._animation) {
            this._animation.state.clearTracks();
            this._animation.visible = false;
        }
    }

    constructor() {
        super();
        this.name = "TheBorderXRipReelHighlighter";

        if (TheBorder.apiPlugin.gameClientConfiguration.boostedBetAllowed) {
            this.init();
        }
    }

    private init(): void {
        this._animation = new PIXI.spine.Spine(TheBorder.assetLoader.getSpineAsset(TheBorderGameAssets.X_RIP_REEL_HIGHLIGHTER));
        this._animation.visible = false;
        this._animation.position.set(60, 390);
        this.addChild(this._animation);
    }

    private resetSpine(): void {
        if (!this._animation.visible) {
            this._animation.visible = true;
            this._animation.updateTransform();
        }
        this._animation.state.clearTracks();
        this._animation.skeleton.setSlotsToSetupPose();
        this._animation.skeleton.setToSetupPose();
        this._animation.state.setEmptyAnimation(0, 0);
    }
}